import {Dimensions, StyleSheet} from 'react-native';

const {width} = Dimensions.get('window');

export const styles = StyleSheet.create({
  container: {paddingBottom: 10},
  child: {
    width: width - 200,
    justifyContent: 'center',
    marginRight: 40,
    // height: 450,
  },
  renderContainer: {flex: 1, marginTop: 10},
});
